import { FormHandles, Scope } from '@unform/core';
import { Form } from '@unform/web';
import { Input } from 'components/Shared';
import { FORM_BACK_ACTION } from 'constants/Common';
import { useValidation } from 'hooks';
import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { CreateDriverActions as CreateActions } from 'store/ducks/drivers';
import { CreateDriverValidator } from 'validators/Drivers';
import * as S from './styles';
import { customMask } from 'utils/customMask';

interface Props {
  onCreate?: () => void;
}

export const DriverCreationForm: React.FC<Props> = ({ onCreate }) => {
  const dispatch: AppDispatch = useDispatch();
  const formRef = useRef<FormHandles>(null);
  const { handleFormErrors, handleApiErrors } = useValidation();

  const { loading: creatingDriver, validationErrors } = useSelector(
    (state: RootState) => state.createDriver
  );

  const onSuccess = useCallback((): void => {
    formRef?.current?.reset();
    onCreate && onCreate();
  }, [onCreate]);

  const onSubmit = useCallback(
    async (data: any): Promise<void> => {
      try {
        formRef?.current?.setErrors({});

        const { schema } = new CreateDriverValidator();
        const validData = await schema.validate(data, {
          abortEarly: false,
        });

        const document = validData.document.replace(/\D/g, '');
        const cellPhone = validData.cellPhone.replace(/\D/g, '');

        dispatch(CreateActions.request({ ...validData, document, cellPhone }, onSuccess));
      } catch (error) {
        handleFormErrors(error, formRef);
      }
    },
    [dispatch, handleFormErrors, onSuccess]
  );

  useEffect(() => {
    handleApiErrors(validationErrors, formRef);
  }, [handleApiErrors, validationErrors]);

  useEffect(() => {
    return () => {
      dispatch(CreateActions.reset());
    };
  }, [dispatch]);

  return (
    <S.Container>
      <Form ref={formRef} onSubmit={onSubmit}>
        <S.FormRow>
          <Input name="name" label="Nome completo" />
          <Input
            name="document"
            label="CPF"
            minLength={14}
            onChange={(e) =>
              (e.target.value = customMask(e.target.value, '999.999.999-99'))
            }
          />
          <Input
            name="cellPhone"
            label="Celular"
            minLength={15}
            onChange={(e) =>
              (e.target.value = customMask(e.target.value, '(99) 99999-9999'))
            }
          />
        </S.FormRow>

        <S.FormActions>
          <S.LinkButton mood="light" to="/configuracoes/motoristas">
            {FORM_BACK_ACTION}
          </S.LinkButton>
          <S.Button type="submit">
            {creatingDriver ? <S.ActivityIndicator /> : 'Salvar'}
          </S.Button>
        </S.FormActions>
      </Form>
    </S.Container>
  );
};
